/* unplugin-vue-components disabled */import script from "./addContractDailog.vue?vue&type=script&setup=true&lang=js"
export * from "./addContractDailog.vue?vue&type=script&setup=true&lang=js"

import "./addContractDailog.vue?vue&type=style&index=0&id=4bcf617d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bcf617d"]])

export default __exports__